import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { Link2Off } from 'lucide-react';

import { useAuthenticatedState } from 'src/authenticated-state/context';
import Responsive from 'src/components/responsive';
import ButtonLink from 'src/components/button-link';
import { isFacebookIntegrationNotification } from 'src/services/api/notifications';
import { usePersistentState } from 'src/services/storage/use-persistent-state';
import InlineBanner, { bannerStyles } from 'src/components/inline-banner/InlineBanner';

export default function FacebookIntegrationAlert() {
    const { pathname } = useLocation();
    const { notifications } = useAuthenticatedState();
    const [isDismissed, setIsDismissed] = usePersistentState('facebookIntegrationAlertDismissed', false);

    const handleDismiss = useCallback(() => {
        setIsDismissed(true);
    }, [setIsDismissed]);

    if (
        pathname.startsWith('/landlord/inner/messages/from-lead') ||
        pathname.startsWith('/landlord/inner/playbooks')
    ) {
        return null;
    }

    const facebookIntegrationNotifications = notifications
        .filter(isFacebookIntegrationNotification)
        .filter((notification) => !notification.is_read_by_user);

    if (facebookIntegrationNotifications.length === 0 || isDismissed) {
        return null;
    }

    const integration = facebookIntegrationNotifications[0];
    const isSettingsPage = pathname.startsWith('/landlord/inner/settings');

    const description = integration.is_informational ?
        integration.text :
        isSettingsPage ?
            'Scroll down to the Facebook section to re-connect.' :
            'There was an error with your Facebook integration. Please review your settings.';

    return (
        <Responsive desktop>
            <InlineBanner
                severity="error"
                icon={<Link2Off size={15} />}
                title="Facebook Integration Error"
                description={description}
                onDismiss={handleDismiss}
                actions={
                    !integration.is_informational && !isSettingsPage && (
                        <ButtonLink
                            variant="outlined"
                            size="small"
                            className={`${bannerStyles.actionBtn} ${bannerStyles.outlined}`}
                            href="/landlord/inner/settings?tab=lead_ingestion"
                            data-testid="facebook-integration-fix-button"
                        >
                            Fix Issue
                        </ButtonLink>
                    )
                }
            />
        </Responsive>
    );
}
